<template>
  <!-- 图片（触发事件） -->
  <div class="id_17 clear">
    <div
      class="img_box"
      :class="{'cursor': canTrigger && +data.radio !== 2}"
      @click="toPage(1)"
    >
      <img ref="img" :src="data.src">
      <div
        class="btn"
        :style="btnStyle"
        @click.stop="toPage(2)"
        v-if="+data.radio === 2 && canTrigger"
      >
        {{ data.btnText || '了解详情' }}
      </div>
    </div>
  </div>
</template>

<script>
import { pcGoodsPayUrl } from '@/assets/js/pcJumpUrl'
import { prepareAsyncNewWindow } from '@/components/badges/utils/openWindow'
/**
 * 图片（触发事件）id=17 前端渲染
 * data 字段说明：
 * - radio: 1=点击整图触发；2=仅点击按钮触发
 * - eventType: 点击后执行的事件类型（不是直接跳转）
 *   1 = 报名关联活动（依赖 seasonId；调级联报名接口）
 * - contestId / seasonId: 关联活动、活动季
 * - btnText / style / color: radio=2 时的按钮文案与样式
 */
export default {
  name: 'id_17',
  props: {
    data: Object
  },
  computed: {
    /** 是否可触发：当前仅支持 eventType=1 且已配 seasonId */
    canTrigger () {
      return +this.data.eventType === 1 && !!this.data.seasonId
    },
    /** 学生端强制手型；过滤后台编辑态残留的 cursor/z-index */
    btnStyle () {
      const raw = this.data.style || ''
      const cleaned = String(raw)
        .replace(/cursor\s*:[^;]+;?/gi, '')
        .replace(/z-index\s*:[^;]+;?/gi, '')
      return cleaned + ';cursor:pointer;'
    }
  },
  methods: {
    /**
     * @param {number} num 1=点图片；2=点按钮
     * radio=2 时忽略图片点击，只响应按钮
     */
    toPage (num) {
      if (num === 1 && +this.data.radio === 2) return
      if (!this.canTrigger) return
      this.handleEvent()
    },
    /** 按 eventType 执行对应事件 */
    handleEvent () {
      const eventType = +this.data.eventType
      switch (eventType) {
        case 1:
          this.enterCascade()
          break
        default:
          break
      }
    },
    /** eventType=1：级联报名关联活动，成功后拉缴费任务列表 */
    enterCascade () {
      // source：当前所在活动季；cascade：后台配置的关联活动季
      const sourceSeasonId = this.$route.query.seasonId || this.$utils.cache('seasonId') || this.$route.params.seasonId
      const cascadeSeasonId = this.data && this.data.seasonId
      if (!sourceSeasonId || !cascadeSeasonId) {
        this.$message && this.$message.error('缺少活动季信息')
        return
      }
      // Safari：接口回调里 window.open 会被拦截，须在点击同步栈内先开空白页
      const popup = prepareAsyncNewWindow()
      const params = {
        sourceSeasonId,
        cascadeSeasonId
      }
      this.$api.post('ENTER_USER_ENTER_CASCADE', params, (res) => {
        // res.data 作为 taskRelationId，再查报名后跳转缴费任务列表
        const taskRelationId = res && res.data
        if (!taskRelationId) {
          popup.cancel()
          this.$message && this.$message.error('未获取到任务 id')
          return
        }
        this.getJumpPayTaskList(taskRelationId, popup)
      }, () => {
        popup.cancel()
      })
    },
    /** 查询报名后跳转缴费任务列表 */
    getJumpPayTaskList (taskRelationId, popup) {
      this.$api.post('ENTER_USER_GETJUNMP_TASKLIST', { taskRelationId }, (res) => {
        console.log(res, 'ENTER_USER_GETJUNMP_TASKLIST')
        const payTaskList = (res && res.data && res.data.payTaskList) || []
        if (!payTaskList.length) {
          // 无费用任务：关闭预开窗，当前页跳转关联活动任务列表
          popup && popup.cancel()
          const { contestId, seasonId } = this.data || {}
          if (!contestId || !seasonId) {
            this.$message && this.$message.error('缺少活动/活动季信息')
            return
          }
          this.$router.push(`/taskList/${seasonId}?contestId=${contestId}`)
          return
        }
        // 有费用：取第一个缴费任务，写入预开窗地址（兼容 Safari）
        const payTaskRelationId = payTaskList[0].taskRelationId
        if (!payTaskRelationId) {
          popup && popup.cancel()
          this.$message && this.$message.error('未获取到缴费任务')
          return
        }
        const payUrl = pcGoodsPayUrl(payTaskRelationId)
        if (!popup) {
          window.open(payUrl, '_blank')
          return
        }
        const openedBefore = popup.opened
        const ok = popup.navigate(payUrl)
        if (!ok) {
          this.$message && this.$message.warning('浏览器拦截了新窗口，请允许弹出式窗口后重试')
        } else if (!openedBefore) {
          this.$message && this.$message.info('浏览器拦截了新窗口，已尝试用其他方式打开')
        }
      }, () => {
        popup && popup.cancel()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 后台配置区基准宽 936px，按钮 168×38；学生端按图片容器宽度等比缩放
$design-width: 936;
$btn-w: 168;
$btn-h: 38;
$btn-font: 16;
.id_17 {
  word-wrap: break-word;
  width: 100%;
  font-size: 0;
  line-height: 0;
  .img_box {
    width: 100%;
    position: relative;
    container-type: inline-size;
    container-name: id17-img;
    img {
      width: 100%;
      display: block;
    }
    .btn {
      position: absolute;
      // 宽高相对图片容器，与后台 168/936、38/936 一致
      width: calc(#{$btn-w} / #{$design-width} * 100%);
      aspect-ratio: #{$btn-w} / #{$btn-h};
      height: auto;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 1.2;
      // cqw = 容器宽度的 1%，随背景图等比变化
      font-size: #{'max(12px, calc(' + $btn-font + ' / ' + $design-width + ' * 100cqw))'};
      border-radius: 999px;
      font-family: OPPOSans-B, OPPOSans;
      font-weight: normal;
      color: #FFFFFF;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 #{'calc(8 / ' + $design-width + ' * 100cqw)'};
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_17.vue